export const API = 'https://api.miheatingcoolingwiki.com/repository-backend/api';